import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_EXAM_LEVEL_AND_RESOURCE_TYPES} from '../../constants/apiUrls';
import {GenericErrorResponse, KeyValueResponse} from '../typings';
import {GET_EXAM_LEVEL_AND_RESOURCE_TYPES_QUERY_KEY} from '../../constants/queryKeys';

// =============================================================================
// Query
// =============================================================================

export interface ExamLevelsAndResourceTypesResponse {
  examLevels: KeyValueResponse[];
  resourceTypes: KeyValueResponse[];
}

interface Input {
  onSuccess: (data: ExamLevelsAndResourceTypesResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetExamLevelsAndResourceTypes = ({onSuccess, onError}: Input) => {
  const getExamLevelsAndResourceTypes = async () => {
    const res = await axiosClient.get<ExamLevelsAndResourceTypesResponse>(
        GET_EXAM_LEVEL_AND_RESOURCE_TYPES
    );
    return res.data;
  };

  return useCustomQuery(
      GET_EXAM_LEVEL_AND_RESOURCE_TYPES_QUERY_KEY,
      getExamLevelsAndResourceTypes,
      {
        onSuccess,
        onError,
      }
  );
};
